export const endpoints = {
  auth: {
    login: '/auth/login',
    revoke: '/auth/revoke',
  },
  commissioner: '/commissioner',
  workshop: '/workshop',
  municipios: '/department',
  users: '/user',
  zones: '/zone',
  branchOffcie: '/office',
  providers: '/provider',
  devices: '/device',
  workshopTypes: '/workshopType',
  profile: '/profile',
  workshopStatus: '/workshop/status',
  reports: {
    diff: '/report/diff',
    census: '/report/census',
    get: '/report',
    update: {
      all: '/report/update',
    },
    compare: '/report/compare',
  },
  systemParameter: '/system-parameter',
} as const;
